import { createReduxAsyncThunk } from 'shared/utils';

import { driversAPI } from '../../api';

import { DRIVERS_STATE } from '../../constants';

import { FuelTaskId } from '../../types';

export const getDriverFuelAssignment = createReduxAsyncThunk(
  `${DRIVERS_STATE}/getDriverFuelAssignment`,
  async (fuelTaskId: FuelTaskId) => {
    const { data } = await driversAPI.getDriverFuelAssignment(fuelTaskId);
    return data;
  }
);
